import React from 'react'

// Replaces react-storefront/session/SessionContext, which was itself just
// React.createContext(). providers/SessionProvider.js supplies the value.
const SessionContext = React.createContext(null)

export default SessionContext
